export default {
	config:{
		add:'Añadir',
		submit:'Aplicar',
		cancel:'Cancelar',
		noData:'No se dispone de datos',
		delete:'Suprimir',
		refresh:'Actualizar',
		back:'Atrás',
		send:'Enviar',
		deleteMessage:'Esta operación eliminará permanentemente el archivo, ¿desea continuar?',
		warnTitle:'Advertir',
		success:'¡Envía el éxito!',
		warnFill:'Por favor, rellene',
		warnNumber:'Introduzca un valor numérico',
		warnInvalid:'Relleno no válido',
		start:'Iniciar',
		confirm:'Confirmar',
		goto:'Por favor, vaya a',
	},
	header:{
		changeLang:'Lenguaje',
		update:'Actualizar',
		reset:'Reestablecer',
		logout:'Cerrar sesión',
	},
	welcome:{
		title:'Bienvenido a GreenPacket CPE',
		button:'Inicio',
		recommend:'Ubicación de instalación recomendada',
		recomText:'Antes de instalar el equipo, se recomienda realizar pruebas de calidad de la señal para determinar la ubicación óptima.',
		next:'Siguiente',
		parsing:'Análisis de las etapas de instalación.',
		step1:'Paso uno',
		step1Text:'Parte inferior del fuselaje, confirma la tarjeta.',
		step2:'Segundo paso',
		step2Text:'Tapa de metal, atornillar en la ranura de la tarjeta.',
		step3:'Paso tres',
		step3Text:'Apriete la cubierta, impermeable y a prueba de polvo.',
		step4:'Paso cuatro',
		step4Text:'Inserción de cable de red, casquillo de sellado.',
		step5:'Paso cinco',
		step5Text:'Apriete la férula, impermeable y segura.',
		step6:'Paso seis',
		step6Text:'La parte posterior del fuselaje, inserte la abrazadera de la manguera.',
		step7:'Paso siete',
		step7Text:'Abroche en el poste de sujeción, apriete y fije.',
		step8:'Paso ocho',
		step8Text:'Ajusta el ángulo y completa la instalación.',
		find:'Ajuste la posición y la dirección del router para encontrar la mejor señal.',
		nowSignal:'Calidad actual de la señal',
		score:'Puntaje',
		suggest:'Excelente señal. Utilice  esta ubicación y ángulo.',
		continue:'Seguir probando',
		signalStrength:'Intensidad de la señal',
		distributed:'Distribución de registros de detección',
		guide:'Guía de Internet',
		guideSsid:'SSID',
		guidePsw:'Contraseña de Wi-Fi',
		samePsw:'Establecer contraseña del dispositivo',
		sameText:'Igual que la contraseña de Wi-Fi',
		oldPsw:'Contraseña antigua',
		newPsw:'Nueva contraseña',
		passwordRuleText:'Contraseña de 8-20 dígitos, debe contener letras mayúsculas y minúsculas, números  y caracteres especiales',
		rules:{
			pwdMust:'La contraseña debe',
			pwdRule:'La contraseña no cumple las normas',
		},
		finish:'Finalizar',
		resetWait:'El dispositivo se está reiniciando ... Por favor, esperen',
		newWlanName:'El nuevo nombre de Wi-Fi es:',
		reloadPage:'Puede cambiar la configuración del dispositivo visitando este sitio web de nuevo',
	},
	login:{
		userName:'Nombre de usuario',
		userPassword:'Contraseña de usuario',
		loginBtn:'Login',
		forgetPsw:'Olvidar contraseña',
		resetText:'Por favor, pulse el botón RESET para restaurar la configuración de fábrica (puede hacer que se pierdan los datos de usuario) y restablecer la contraseña.',
	},
	menu:{
		home:'Inicio',
		mobilenet:'Red móvil',
		easy:'Configuración básica de Wi-Fi',
		terminal:'Dispositivos',
		tools:'Herramientas',
		sms:'SMS',
		settings:'Avanzado',
		advanced:{
			DeviceInformation:'Información del dispositivo',
			NetworkMenu:{
				Network:'Red',
				APNManagement:'Gestión de APN',
				DHCPSettings:'Configuración de DHCP',
				LTEConfiguration:'Configuración LTE',
				CellSelection:'Selección de celdas',
				LockBand:'Bloqueo de Banda',
				NetworkSelection:'Selección de red',
				CommandShell:'Linea de comandos',
			},
			WiFiMenu:{
				WiFi:'Wi-Fi',
				WLANStatus:'Estado WLAN',
				WLANSettings:'Configuración WLAN',
				WPS:'WPS',
				MACFILTER:'FILTRO MAC',
			},
			FirewallMenu:{
				Firewall:'Cortafuegos',
				FirewallSettings:'Configuración del cortafuegos',
				ALG:'ALG',
				PortForwarding:'Port Forwarding',
				DMZsettings:'Configuración DMZ',
				UPnP:'UPnP',
				IPFiltering:'Filtrado IP',
				URLFiltering:'Filtrado de URL',
				PortFiltering:'Filtrado de puertos',
			},
			SystemMenu:{
				System:'Sistema',
				Maintenance:'Mantenimiento',
				DDNS:'DDNS',
				General:'Generalidades',
				Ping:'Ping',
				Update:'Actualización',
				TR069:'TR069',
				Iperf:'Iperf',
			},
			VoiceMenu:{
				VoiceSettings:'Voice Settings',
				SIPSever:'SIP Server',
				DigitalMap:'Digital Map',
			}
		}
	},
	home:{
		netStatusYes:'Red conectada',
		netStatusNo:'Red no conectada',
		myDevice:'Mi dispositivo',
		devices:'Conectar dispositivos',
		moreInternet:'Más configuraciones de red',
		moreInfo:'Más información del dispositivo',
		moreDevices:'Gestión de terminales',
	},
	mobileNetwork:{
		pageConnect:'Conexión a Internet',
		pageConnectInfo:{
			text:'El nombre del punto de acceso (APN) es el nombre de la información de configuración leída por el dispositivo, que se utiliza para configurar la conexión con la gestión de la red entre la red de telefonía móvil del operador y la red pública. En la mayoría de los casos, su dispositivo ha realizado estos ajustes en el archivo del sistema, y puede completar automáticamente la información de APN en el enlace.',
			apnName:'Nombre APN',
			classId:'ID de clase',
			IpType:'Tipo de IP',
			auth:'Autenticación',
			username:'Nombre de usuario',
			password:'Contraseña',
			up32:'Hasta 32 caracteres',
			up64:'Hasta 64 caracteres',
			MaxLimit:'Límite máximo: 16',
			None:'None',
		},
		pageSearch:'Búsqueda de red móvil',
		pageSearchInfo:{
			text:'El dispositivo es compatible con "Internet inteligente", selecciona automáticamente una mejor red y tiene una mejor experiencia de Internet',
			NetworkingMode:'Modo de red',
			InternetSearchMethod:'Método de búsqueda en Internet',
		},
		search:'Auto',
	},
	myDevicesInfo:{
		SystemInfomation:'Información del sistema',
		VersionInfomation:'Información de laversión',
		LANStatus:'Estado de LAN',
		RunningTime:'Tiempo de ejecución',
		ProductModel:'Modelo de producto',
		HardwareVersion:'Versión de hardware',
		SoftwareVersion:'Versión de software',
		SerialNumber:'Número de serie',
		MACAddress:'Dirección MAC',
		WanIP:'Dirección IP WAN',
		IPAddress:'Dirección IP',
		SubnetMask:'Máscara de subred',
	},
	devicesManage:{
		title:'Gestión de terminales',
		text:'Visualizar y gestionar toda la información del terminal',
		WiFiStatus:'Estado de Wi-Fi',
		Frequency:'Frecuencia (Canal )',
		SecurityMode:'Modo de seguridad',
		DeviceList:'Lista de dispositivos',
		onlineTable:'Terminal en línea',
		outlineTable:'Terminal fuera de línea',
		allowNet:'Permitir internet',
		stopTime:'Plazo de caducidad del asignación DHCP',
		editName:'Editar nombre',
		deleteText:'¿Está seguro de eliminar el dispositivo actual',
	},
	easyWlan:{
		title:'Wi-Fi configuración fácil',
		text:'Modificar rápidamente el nombre y la contraseña de Wi-Fi',
		first5G:'5G preferido',
		first5GMessage:'Cuando las señales WiFi 2.4G y 5G se muestran simultàneamente, 5G será la señal preferida, pues es la conexión mas rápida bajo las mismas condiciones de intensidad de señal. Para ajustar 2.4GHz y 5Ghz de forma individual, por favor deshabilite el interruptor que muestra ambas señales WiFi al mismo tiempo.',
		SSID:'SSID',
		SecurityPolicy:'Política de seguridad',
		SecurityMode:'Modo de seguridad',
		WPAOption:'Opción WPA',
		Passwordrules:{
			PasswordrulesText:'Reglas de contraseña',
			UserNamerulesText:'Reglas de nombre de usuario',
			rules1:'La longitud de la cadena en modo WEP es de 5 o 13 dígitos.',
			rules2:'En otros modos, la cadena está limitada a 8-32 bits.',
			rules3:'Por favor Introduzca una contraseña de 5 o 13 de longitud.',
			rules4:'Por favor Introduzca una contraseña de 8 a 32 años de longitud.',
			rules5:'Solo ingresa A-Z, a-z, 0-9, carácter especial.',
			rules6:'La longitud de la cadena está limitada a 1 a 32 dígitos.',
			warnMessage:'Cambiar una configuración hará que el Wi-Fi se desconecte temporalmente y puede perder su conexión. Si  esto sucede, vuelva a conectarse a su Wi-Fi y actualice la página.',
			successMessage:'Configuración exitosa, vuelva a conectarse con sus nuevas credenciales de wifi.'
		}
	},
	sms:{
		inbox:'Bandeja de entrada',
		outbox:'Bandeja de salida',
		settings:'Configuración',
		newMessage:'Nuevo mensaje',
		phoneNumber:'Número',
		content:'Contenido',
		date:'Fecha',
		time:'Tiempo',
		Recipient:'Destinatario',
		RemainingWords:'Palabras restantes',
		sender:'Remitente',
		smsCenterNumber:'Número de centro de SMS',
		warnLimit:'La longitud supera el límite',
		warnFill:'Por favor, rellene y aplique',
		warnNumber:'Por favor, rellene el número de centro de SMS',
	},
	dhcpSettings:{
		LANHostSettings:'Configuración de host LAN',
		LocalIPAddress:'Dirección IP local',
		SubnetMask:'Máscara de subred',
		LANDHCPSettings:'Configuración DHCP de Red LAN',
		DHCPServer:'Servidor DHCP',
		StartIP:'IP de inicio',
		EndIP:'IP final',
		LeaseTime:'Tiempo(s) de asignación DHCP',
		StaticRouteSettings:'Configuración de ruta estática',
		Index:'Índice',
		DestinationIP:'IP de destino',
		RouteSubnetMask:'Máscara de subred de ruta',
		Gateway:'Puerta de enlace',
		warnIp1:'La dirección IP local no es válida',
		warnSubnetMask:'La máscara de subred no es válida',
		warnStartIp:'Introduzca un número entero mayor que 0 y menor o igual que 255',
		warnEndIp:'La dirección IP final debe ser mayor o igual que la IP de inicio',
		warnTime:'Rellene el valor calificado',
	},
	CellSelection:{
		Priority:'Prioridad',
		NetworkMode:'Modo de red',
	},
	LockBand:{
		TechnologyModeSetting:'Configuración del modo de tecnología',
	},
	CommandShell:{
		CommandRunningResults:'Resultados de ejecución de comandos',
		Command:'Comando',
		warnEmpty:'El comando no puede estar vacío',
	},
	WLANStatus:{
		APInformation:'Información de Punto de Acceso',
		SSID:'SSID',
		TxPower:'Potencia Tx',
		Mode:'Modo',
		Channel:'Canal',
		ChannelBandwidth:'Ancho de banda de canal',
		Rates:'Velocidad',
		Security:'Seguridad',
	},
	WLANSettings:{
		BasicSettings:'Configuración básica',
		Name:'Nombre',
		WLAN:'WLAN',
		SSID:'SSID',
		CountryCode:'Código de país',
		Mode:'Modo',
		ChannelBandwidth:'Ancho de banda de canal',
		ChannelMode:'Modo de canal',
		Channel:'Canal',
		TxPower:'Potencia Tx',
		MaxSTAs:'STAs Máximos',
		MaxLength:'Longitud máxima',
	},
	WLANWps:{
		settings:'Configuración',
		WPSMode:'Modo WPS',
	},
	MacFilter:{
		nodeTitle:'Filtro MAC',
		MACFilterMode:'Modo de filtro MAC',
		WLANAccessList:'Lista de acceso WLAN',
		warnEmpty:'Esta dirección MAC no puede estar vacía',
		warnAddress:'Esta dirección MAC no cumple con el estándar',
		whitelist:'Lista blanca',
		blacklist:'Lista negra',
	},
	FirewallSettings:{
		FirewallProtection:'Protección cortafuegos',
		SPIFirewall:'Cortafuegos SPI',
		BlockWANRequests:'Bloquear solicitudes WAN',
		BlockAnonymousInternetRequests:'Bloquear solicitudes anónimas de Internet',
		FilterIDENT:'Filtrart IDENT (puerto 113)',
	},
	Alg:{
		IPSecPassthrough:'Paso IPSec',
		L2TPPassthrough:'Paso L2TP',
		PPTPPassthrough:'Paso PPTP',
		FTPPassthrough:'Paso FTP',
		H323Passthrough:'Paso H323',
		SIPPassthrough:'Paso SIP',
		RTSPPassthrough:'Paso RTSP',
	},
	PortForwarding:{
		PortForwardingList:'Lista de reenvío de puertos',
		Application:'Solicitud',
		PortFrom:'Desde Puerto',
		Protocol:'Protocolo',
		IPAddress:'Dirección IP',
		PortTo:'Hasta Puerto',
		Enable:'Activar',
		Disable:'Desactivar',
		Both:'Ambos',
	},
	Dmz:{
		DMZEnableStatus:'Estatus de Habilitación de DMZ',
		DMZHostIPAddress:'Dirección IP del host DMZ',
		ExcludeWebServerPort:'Excluir puerto de servidor web',
		ExcludeTelnetSSHPort:'Excluir puerto Telnet/SSH',
		ExcludePingService:'Excluir servicio de Ping',
	},
	Upnp:{
		UPnPConfiguration:'Configuración UPnP',
		UPnPService:'Servicio UPnP',
		UPnPNotificationInterval:'Intervalo de notificación UPnP',
		DeleteAll:'Eliminar todo',
	},
	IPFiltering:{
		IPFilter:'Filtro IP',
		EnableIPFilter:'Habilitar filtro IP',
		message:'la función de filtrar las direcciones IP de la red de área local inalámbrica[WLAN], puede utilizarse para restringir el acceso del usuario a los servicios de Internet específicos.',
		warnIp:'La dirección IP no es válida',
		maxLimit10:'Límite máximo: 10',
		empty:'Esta dirección IP no puede estar vacía',
		standard:'Esta dirección IP no cumple el estándar',
	},
	URLFiltering:{
		URLFilter:'Filtro de URL',
		EnableURLFilter:'Habilitar filtro de URL',
		message:'La función de filtrar la URL en la red de área local inalámbrica[WLAN], puede utilizarse para restringir el acceso del usuario a los servicios de Internet específicos.',
		maxLimit10:'Límite máximo: 10',
	},
	PortFiltering:{
		PortFilter:'Filtro de puerto',
		EnablePortFilter:'Habilitar filtro de puerto',
		message:'La función de filtro de puerto en la red de área local inalámbrica[WLAN], puede utilizarse para restringir el acceso del usuario a los servicios de Internet específicos.',
		maxLimit10:'Límite máximo: 10',
		PortStart:'Puerto de Inicio',
		PortEnd:'Puerto de Fin',
	},
	Maintenance:{
		Reboot:'Reiniciar',
		RebootText:'Haga clic en Reiniciar para reiniciar el dispositivo',
		FactoryReset:'Reestablecimiento de Fabrica',
		FactoryResetText:'Haga clic en Restablecimiento de fábrica para restaurar el dispositivo a su configuración de fábrica',
		FactoryResetWarn:'Haga clic en el botón Restablecimiento de fábrica para restablecer',
		Syslog:'Logs del Sistema',
		Download:'Descargar',
		Backup:'Archivo de configuración de copia de seguridad',
		BackupText:'Para hacer una copia de seguridad del archivo de configuración actual, haga clic en  Descargar',
		Restore:'Restaurar archivo de configuración',
		RestoreText:'Para restaurar el archivo de configuración, especifique la ruta del archivo de congiguración local,importe el archivo y haga clic en Cargar para restaurar el archivo de configuración',
		Upload:'Subir',
	},
	DDNS:{
		DDNSService:'Servicio DDNS',
		UserName:'Nombre de usuario',
		Password:'Contraseña',
		HostName:'Nombre de host',
		Status:'Estado',
		InternetIPAddress:'Dirección IP de Internet',
	},
	General:{
		ChangePassword:'Cambiar contraseña',
		OldPassword:'Contraseña antigua',
		NewPassword:'Nueva contraseña',
		Passwordrules:'Contraseña de 8-20 dígitos, debe contener letras mayúsculas y minúsculas, números  y caracteres especiales',
		ReentertoConfirm:'Reintroduzca para confirmar',
		TimeSettings:'Configuración de tiempo',
		NTPEnableStatus:'Estatus de Habilitación de NTP',
		TimeZone:'Zona horaria',
		SummerTimeEnable:'Habilitar Horario de Verano',
		NTPServer:'Servidor NTP',
		UseLocalHostTime:'Usar hora de host local',
		RefreshInterval:'Intervalo de actualización',
		minutes:'minutos',
		AutoRefresh:'Auto-Refrescar',
		rePasswordMust:'Introduzca nueva contraseña otra vez',
		passwordSame:'¡Las dos entradas de contraseña son incoherentes!',
	},
	Ping:{
		PingTest:'Prueba de Ping',
		IPProtocol:'Protocolo IP',
	},
	Update:{
		LocalFirmwareUpdate:'Actualización de firmware local',
		LocationText:'Ubicación',
		ChooseFile:'Elegir archivo',
	},
	systemTr:{
		ACSURL:'URL de ACS',
		ACSUserName:'Nombre de usuario de ACS',
		ACSUserPassword:'Contraseña de usuario de ACS',
		PeriodicInform:'Periodic Inform',
		PeriodicInformInterval:'Intervalo de Periodic Inform',
		PeriodicInformTime:'Hora de Periodic Inform',
		RequestUserName:'Nombre de Usuario CPE',
		RequestUserPassword:'Contraseña de Usuario CPE',
	},
	Iperf:{
		IperfSettings:'Configuración de Iperf',
		Status:'Estado',
		ServerAddress:'Dirección del servidor',
		ServerPort:'Puerto del servidor',
		ManagementPort:'Puerto de gestión',
		MeasurementTime:'Tiempo de medición',
		Seconds:'Segundos',
		ProtocolType:'Tipo de protocolo',
		WindowSize:'Tamaño de ventana',
		TCPClientNumber:'Número de cliente TCP',
		DataLength:'Longitud de los datos',
		UDPBandwidth:'Ancho de banda UDP',
		UplinkSpeed:'Velocidad de Uplink',
		DownlinkSpeed:'Velocidad de Downlink',
		UplinkLatency:'Latencia de Uplink',
		DownlinkLatency:'Latencia de Downlink',
	},
	VoiceSettings:{
		RegisterStatus:'VoIP Register Status',
		AuthorizationSatus:'Authorization Satus',
		RegServer:'Reg Server',
		Address:'Address',
		Port:'Port',
		SIPDomain:'SIP Domain',
		Domain:'Domain',
		SIPProxy:'SIP Proxy',
		Enable:'Enable',
		Authorization:'Authorization',
		AuthName:'Auth Name',
		PhoneName:'Phone Name',
		RegAccount:'Reg Account',
		RegPassword:'Reg Password',
	},
	DialtalMap:{
		DialPlan:'Dial Plan',
	}
}
